import { render } from "./LearningMaterial.vue?vue&type=template&id=7ba15c88"
import script from "./LearningMaterial.vue?vue&type=script&lang=js"
export * from "./LearningMaterial.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__